import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Tooltip/tooltip';
import { css } from '@patternfly/react-styles';
export var TooltipContent = function TooltipContent(_a) {
  var className = _a.className,
      children = _a.children,
      isLeftAligned = _a.isLeftAligned,
      props = __rest(_a, ["className", "children", "isLeftAligned"]);

  return React.createElement("div", Object.assign({
    className: css(styles.tooltipContent, isLeftAligned && styles.modifiers.textAlignLeft, className)
  }, props), children);
};